import { ReactComponent as Transfertohospital } from "../static/images/unableToAssessWound/transfertohospital.svg";
import { ReactComponent  as Outoffacility } from "../static/images/unableToAssessWound/outoffacility.svg";
import { ReactComponent as Other} from "../static/images/unableToAssessWound/other.svg";
//buttons
export const LOGIN_BUTTON = 'Login';
export const REGISTER_BTN = 'Register';
export const CANCEL_BTN = 'Cancel';
export const SAVE_BTN = 'Save';

//ids
export const EMAIL_ID = 'email';
export const PASSWORD_ID = 'password';
export const CONFIRM_PASSWORD_ID = 'confirmPassword';
export const LOGIN_ID = 'login-btn';
export const FIRST_NAME_ID = 'firstName';
export const LAST_NAME_ID = 'lastName';
export const CUSTOMER_NUMBER_ID = 'customerNumber';
export const PHONE_ID = 'phone';
export const CHECK_TERMS_ID = 'checkTerms';
export const REGISTER_BTN_ID = 'register-btn';
export const PATIENT_STATUS_ID = 'patientStatus';
export const GENDER_ID = 'gender';
export const DATE_OF_BIRTH_ID = 'dateOfBirth';
export const PHONE_TYPE_ID = 'phoneType';
export const ADDRESS_ID = 'address';
export const APT_SUITE_ID = 'aptSuiteOther';
export const CITY_ID = 'city';
export const STATE_ID = 'state';
export const ZIP_CODE_ID = 'zipCode';
export const ADMISSION_DATE_ID = 'admissionDate';
export const ADMISSION_TIME_ID = 'admissionTime';
export const WRISTBAND_ID = 'wristband';
export const UNIT_ID = 'unit';
export const FLOOR_ID = 'floor';
export const ROOM_ID = 'room';
export const REASON_FOR_VISIT_ID = 'reasonForVisit';
export const CANCEL_ID = 'cancel';
export const SUBMIT_ID = 'submit';
export const PATIENT_PICTURE_ID = 'patientPicture';
export const NE1_WMS_STATUS_ID = 'ne1WmsStatus';
export const INSURANCE_PAYER_ID = 'insurancePayer';
export const SMOKING_STATUS_ID = 'smokingStatus';
export const COMORBID_CONDITIONS_ID = 'comorbidConditions';
export const DIABETIC_ID = 'diabetic';
export const BODY_MASS_INDEX_ID = 'bodyMassIndex';
export const CUSTOMER_NAME_ID = 'customerName';
export const STREET_ADD_ID = 'streetAddress';
export const POSTAL_CODE_ID = 'postalCode';
export const REGION_ID = 'Region';
export const ACC_GROUP_CODE_ID = 'accountGroup';
export const CUSTOMER_GROUP_NAME_ID = 'customerGroup';
export const SALES_OFFICE_DESC_ID = 'salesOfficeDescription';
export const DIVISION_MANAGER_NAME_ID = 'divisionManagerName';
export const WOUND_CARE_SALES_REP_NAME_ID = 'woundCareSalesRepName';
export const DISTRICT_NAME_ID = 'districtName';
export const COUNTRY_CODE_ID = 'countryCode';
export const ROLE_ID = 'roleID';
export const LIST_VIEW_ICON = 'listViewMenuIcon';

// export const ANNOUNCEMENT_ID = 'announcementID';
// export const SALES_OFFICE_ID = 'salesOfficeID';
// export const ANNOUNCEMENT_DESCRIPTION_ID = 'announcementDescriptionID';
export const CONTENTURL = 'contentUrl';
export const LIST_VIEW_MENU_SEQUENCE_ID = 'sequence'
//labels
export const EMAIL_LBL = 'Email';
export const PASSWORD_LBL = 'Password';
export const CONFIRM_PASSWORD_LBL = 'Confirm password';
export const FORGOT_PASSWORD_LBL = 'Forgot password?';
export const LOGIN_LBL = 'Login';
export const WELCOME_LBL = 'Welcome!';
export const LOGREG_LBL = "Log In | Register"
export const NO_ACCOUNT_LBL = 'Don\'t have an account?';
export const REGISTER_LBL = 'Register';
export const REGISTER_HEAD_LBL = 'Register for an account';
export const ALREADY_REGISTERED_LBL = 'Already have an account?';
export const FIRST_NAME_LBL = 'First name';
export const LAST_NAME_LBL = 'Last name';
export const CUSTOMER_NUMBER_LBL = 'Customer Number';
export const PHONE_LBL = 'Phone number';
export const PRIVACY_POLICY_LBL = 'Privacy Policy';
export const TERMS_LBL = 'Terms & Conditions';
export const EDIT = 'Edit';
export const PATIENT_STATUS_LBL = 'Patient Status:';
export const DISCHARGED_DATE_LBL = 'Discharge Date:';
export const TRANSFERED_DATE_LBL = 'Transfer Date:';
export const FACILITY_LBL = 'Facility:';
export const FACILITY_LOCATION_LBL = 'Facility/Location:';
export const GENDER_LBL = 'Gender';
export const DATE_OF_BIRTH_LBL = 'Date of birth';
export const REASON_FOR_VISIT_LBL = 'Reason for visit';
export const CITY_LBL = 'City';
export const ZIP_CODE_LBL = 'Zip code';
export const APT_SUITE_OTHER_LBL = 'Apt/Suite/Other';
export const ADDRESS_LBL = 'Address';
export const PHONE_TYPE_LBL = 'Phone type';
export const STATE_LBL = 'State';
export const ADMISSTION_DATE_LBL = 'Admission date';
export const WRISTBAND_LBL = 'Wristband';
export const UNIT_LBL = 'Unit';
export const FLOOR_LBL = 'Floor';
export const ROOM_LBL = 'Room';
export const PATIENT_PICTURE_LBL = 'Patient picture';
export const BROWSE_LBL = 'Browse';
export const BODY_MASS_INDEX_LBL = 'Body Mass Index';
export const DIABETIC_LBL = 'Diabetic';
export const COMORBID_CONDITIONS_LBL = 'Comorbid Conditions';
export const SMOKING_STATUS_LBL = 'Smoking Status';
export const INSURANCE_PAYER_LBL = 'Payer';
export const NE1_WMS_STATUS_LBL = 'NE1 WMS Status';
export const CUSTOMER_NAME_LBL = 'Customer Name';
export const STREET_ADD_LBL = 'Street Name';
export const POSTAL_CODE_LBL = 'Zip Code';
export const REGION_LBL = 'State';
export const ACC_GROUP_CODE_LBL = 'Account Group Code';
export const CUSTOMER_GROUP_NAME_LBL = 'Customer Group Name';
export const SALES_OFFICE_DESC_LBL = 'Sales Office Description';
export const DIVISION_MANAGER_NAME_LBL = 'Division Manager Name';
export const WOUND_CARE_SALES_REP_NAME_LBL = 'Wound Care Sales Rep Name';
export const CUSTOMER_STREET_LBL = 'Street Name';
export const CUSTOMER_PHONE_LBL = 'Phone Number';
export const CUSTOMER_POSTAL_LBL = 'Zip Code';
export const REGION_CODE_LBL = 'State Code';
export const ACCOUNT_GROUP_CODE_LBL = 'Account Group Code';
export const SALES_OFFICE_LBL = 'Sales Office Description';
export const DIVISION_MANAGER_LBL = 'Division Manager Name';
export const WOUND_CARE_SALES_REP_LBL = 'Wound Care Sales Rep Name';
export const DISTRICT_NAME_LBL = 'District Name';
export const COUNTRY_CODE_LBL = 'Country Code';
export const ROLE_LBL = 'Role';
export const USER_TYPE_LBL = 'User Type';
export const SEQUENCE = 'Sequence:';
export const SEQUENCE_LBL = 'Sequence:';
export const RE_ADMITTED_DATE_LBL = 'Re-Admit Date :';
export const ADMITTED_DATE_LBL = 'Admit Date :';
// export const ANNOUNCEMENT_NAME_LBL = 'Announcement Name';
// export const SALES_OFFICE_NAME_LBL = 'Sales Office';
// export const ANNOUNCEMENT_DESCRIPTION_LBL = 'Announcement Description';
export const UPLOAD_ICON = 'Upload Icon';
export const EXTRENAL_URL = 'External URL';
export const WEB_VIEW_URL = 'Web View URL';
export const CREATE_FILTER = 'Create Filter';
export const CREATE_LIST_VIEW_MENU = 'Create List View Menu';
export const UPLOAD_USER_PICTURE = 'Upload Picture';
export const DIVISION_LBL = 'Division'
export const MATERIAL_NUMBER_LBL = 'Material #';
export const MATERIAL_DESCRIPTION_LBL = 'Material Description';
export const MATERIAL_GROUP_CODE_LBL = 'Material Group Code';
export const MATERIAL_GROUP_DESCRIPTION_LBL = 'Material Group Description';
export const PRODUCT_CATEGORY_CODE_LBL = 'Product Category Code';
export const PRODUCT_CATEGORY_DESCRIPTION_LBL = 'Product Category Description';
export const PRODUCT_FAMILY_CODE_LBL = 'Product Family Code';
export const PRODUCT_FAMILY_DESCRIPTION_LBL = 'Product Family Description';
export const PRODUCT_MANAGER_LBL = 'Product Manager';
export const MANUFACTURER_LBL = 'Manufacturer';
export const UNIT_OF_MEASURE_LBL = 'Unit of Measure'
export const QUANTITY_LBL = 'Quantity';
export const GTIN_LBL = 'GTIN #';
export const UPC_LBL = 'UPC';
export const HCPSC_CODE_LBL = 'HCPSC Code';
export const MATERIAL_STATUS_LBL = 'Material Status'
export const MULTISELECT_SUB_LABLE = 'Select all that apply';
export const HPIS_LBL = 'HPIS'
export const UNSPSC_CODE_LBL = 'UNSPSC Code'
export const MEDROUTE_LBL = 'Medroute'
export const RX_LBL = 'RX Only'
export const PRODUCT_TYPE_LBL = 'Product Type'
export const WIPE_TYPE_LBL = 'Wipe Type'
export const PRODUCT_USE_LBL = 'Product Use'
export const UNIT_COMPATIBILITY_LBL = 'Unit Compatibility'
export const LENGTH_LBL = 'Length (in)'
export const BRAND_LBL = 'Brand'
export const PACKAGE_TYPE_LBL = 'Package Type'
export const HPR_Worst_Tissue_Type = 'HPR - Worst Tissue Type'
export const MRN_Number = 'MRN #'




// Headings
export const CONTACT_INFORMATION_HEAD = 'Contact Information';
export const CARE_RECORD_HEAD = 'Care Record';
export const RECORD_CREATED_HEAD = 'Record Created';
export const FACILITY_HEAD = 'Facility/Location';
export const ABOUT_CUSTOMER_HEAD = 'About Customer';
export const USER_INFORMATION_HEAD = 'User Information';

//aria labels
export const EMAIL_ARIA = 'Email';
export const PASSWORD_ARIA = 'Password';
export const CONFIRM_PASSWORD_ARIA = 'Confirm Password';
export const FIRST_NAME_ARIA = 'First Name';
export const LAST_NAME_ARIA = 'Last Name';
export const CUSTOMER_NUMBER_ARIA = 'Customer Number';
export const PHONE_ARIA = 'Phone';


//validation messages 
export const SUCCESS = undefined;
export const FIRST_NAME_REQUIRED = 'Enter your first name';
export const LAST_NAME_REQUIRED = 'Enter your last name';
export const CUSTOMER_NUMBER_REQUIRED = 'Enter your Medline account number';
export const EMAIL_REQUIRED = 'Enter your work email address';
export const COMPANY_EMAIL_REQUIRED = 'Enter your company email address';
export const EMAIL_INVALID = 'Enter your email address in format: name@yourcompany.com';
export const PASSWORD_REQUIRED = 'Enter your password';
export const SELECT_PASSWORD_REQUIRED = 'Select a password';
export const SELECT_NEW_PASSWORD = 'Select a new password';
export const CONFIRM_PASSWORD_REQUIRED = 'Re-enter password to confirm';
export const GENDER_REQUIRED = 'Gender is required';
export const PHONE_REQUIRED = 'Enter your phone number';
export const VALID_PHONE = 'Enter a valid phone number';
export const CHECK_TERMS = 'Please check the box to indicate you have read and agree to the Privacy Policy and Terms & Conditions';
export const PASSWORD_NOMATCH = 'Passwords does not match'
export const NO_FUTURE_DATE = 'Date of Birth should not be a future date';
export const PATIENT_GENERAL_ERROR = 'Fill the mandatory fields';
export const DOB_REQUIRED = 'Date of Birth is required';
export const CUSTOMER_GENERAL_ERROR = 'Fill the mandatory fields';
export const CUSTOMER_NAME_REQUIRED = 'Customer name is required';
export const STREET_ADDRESS_REQUIRED = 'Street address  is required';
export const REGION_REQUIRED = 'State is required';
export const CITY_REQUIRED = 'City is required';
export const POSTAL_NUMBER_REQUIRED = 'Zip code is required';
export const POSTAL_INVALID = 'Enter a valid postal number';
export const ACC_GROUP_REQUIRED = 'Account group code is required';
export const DOMAIN_REQUIRED = 'Domain is required';
export const UPDATE_SUCCESS = 'Your changes have been successfully saved'//MSH-33139
export const CUSTOMER_UPDATE_SUCCESS = 'Your changes have been successfully saved'
export const UPDATE_FAILURE = 'Data update Failed!'
export const DOMAIN_INVALID = 'Enter a valid domain address';
export const ADMISSION_DATE_REQUIRED = 'Enter Patient’s Admission Date & Time';
export const NAME_REQUIRED = 'Name is required';
export const GENERAL_ERROR = 'Fill all mandatory fields';
export const ANNOUNCEMENT_NAME_REQUIRED = 'Please enter a Name';
export const SALES_OFFICE_REQUIRED = 'Please select a sales office';
export const ANNOUNCEMENT_DESCRIPTION_REQUIRED = 'Please enter a Description';
export const SEQUENCE_NUMBER = 'Please enter sequence number';
export const CONTENT_URL = 'Content URL is required';
export const SEQUENCE_VALID = 'Please enter valid sequence number';
export const ENTER_NAME = 'Please enter a name';
export const VALID_URL = 'Enter valid URL';
export const MEASUREMENT = 'Please enter number';
export const VALID_FIRST_NAME = 'Enter a valid first name';
export const VALID_LAST_NAME = 'Enter a valid last name';
export const VALID_EXISTING_SEQUENCE_NUM = 'Sequence already exists';
export const VALID_FORMULARY_ERROR_MSG1 = 'This customer is already assigned with formulary';
export const VALID_FORMULARY_ERROR_MSG2 = 'This formulary already assigned to another customer';
export const ASSIGNED_FORMULARY_SUCCESS = 'Formulary has been assigned successfully';
export const ASSIGNED_FORMULARY_REQUIRED = 'Enter formulary id or name';
export const MATERIAL_NUMBER_REQUIRED = 'Material number is required';
export const MATERIAL_DESCRIPTION_REQUIRED = 'Material description is required';
export const MATERIAL_GROUP_CODE_REQUIRED = 'Material code is required';
export const MATERIAL_GROUP_DESCRIPTION_REQUIRED = 'Material group description is required';
export const PRODUCT_CATEGORY_CODE_REQUIRED = 'Product category code is required';
export const PRODUCT_CATEGORY_DESCRIPTION_REQUIRED = 'Product category description is required';
export const PRODUCT_FAMILY_CODE_REQUIRED = 'Product family code is required';
export const PRODUCT_FAMILY_FAMILY_DESCRIPTION_REQUIRED = 'Product family description is required';
export const PRODUCT_MANAGER_REQUIRED = 'Product manager is required';
export const DIVISION_CODE_REQUIRED = 'Division code is required';
export const SURGICAL_DEBRIDEMENT_PERFORMED = 'Was There Surgical Debridement Performed is required';
export const DEBRIDEMENT_PERFORMED_BY = 'Sharp/Surgical Debridement Performed By is required';
export const NON_EXCISIONAL_APPROACH = 'Non-excisional approach is required';
export const TYPE_OF_PROCEDURE = 'Type of Sharp/Surgical Debridement Procedure is required';
export const DEPTH_OF_DEBRIDEMENT = 'Depth of Debridement - Deepest Level is required';
export const INSTRUMENTS_USED = 'Instruments Used is required';
export const ERROR_DEBRIED_NECROTIC_SKIN = 'Surface Area Debrided of Necrotic Skin is required';
export const GENERAL_ERROR_MARKETING_DESC = 'Please fill the mandatory field '
export const DRESSING_APPEARANCE_ERROR = 'Surface Area Debrided of Necrotic Skin is required';
export const CURRENT_PASSWORD_REQUIRED = 'Enter your current password';
export const NEW_PASSWORD_REQUIRED =  'Enter a new password';
export const MRN_REQUIRED = "Enter MRN number";
export const VALID_MRN_NUMBER = " Enter a valid MRN number"
export const SEQUENCE_ERROR = "This sequence number is assigned to another banner. Please use a different sequence number";
export const LAYOUT_ALREADY_EXIST = "Layouts name already exist";

//placeholder
export const EMAIL_PHDR = 'name@yourcompany.com';
export const PASSWORD_PHDR = '***********';
export const PHONE_PHDR = '';
export const CUSTOMER_NUMBER_PHDR = '#'
export const LAST_NAME_PHDR = 'Smith'
export const FIRST_NAME_PHDR = 'John'
export const USER_PROFILE_PHDR = 'Add a couple of words about what is important to you when caring for a patient.' //changed placeholder

//API base url
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081'
export const API_KEY = process.env.REACT_APP_API_KEY
export const CHATBOT_API_KEY = process.env.REACT_APP_CHATBOT_API_KEY;

//endpoints
//export const AUTHENTICATE = '/userlogin'; Default Version 
//export const AUTHENTICATE = '/userloginv1'; //V1 Version 
export const AUTHENTICATE = '/userloginv2'; //V2 Version 
export const USER_DETAIL = '/userdetailv1';
export const FORGOT_PASSWORD = '/forgotpassword';
export const REGISTRATION = '/v1/registeruser';
export const USER_ACTIVATION = '/useractivation';
export const RESETPASSWORD = '/resetpassword';
export const RESEND_USER_ACTIVATION = '/resenduseractivation';
export const OTP_CODE = '/VerificationCode';
export const UPLOAD_CHECK = '/bulk/patients/status';
export const UPLOAD_CHECK_CUSTOMER = '/bulk/customers/status';
export const UPLOAD_CHECK_USER = '/bulk/users/status';
export const FACILITY_CHECK_BILLING = '/facility/status'
export const PATIENT = '/patients';
export const ADMIN_PATIENT_LIST = '/admin/patients';
export const WOUND_IMAGE_MEASUREMENT = '/WoundImageMeasurement';
export const UPLOAD_PATIENT_FILE = '/bulk/patients';
export const DISCHARGED_PATIENT_API_URL = '/patients/updatePatientADT';
//export const GET_ASSESSMENTS = '/patients/{0}/assessments';
export const GET_ASSESSMENTS = '/patients/{0}/assessmentsV2Pagination'; //Version1 updated for Label feature to version2
export const GET_TOGGLESTATUS = '/patients/assessments/'; // Tissuetype toogle status
export const DELETE_ASSESSMENT = '/patients/{0}/assessments/{1}';
export const DELETE_CHILD_ASSESSMENT = '/patient/initial/reeval/assessment';
export const DELETE_PARENT_ASSESSMENT = '/patient/initial/assessment';
export const WOUND_EVENTS_ACTIVITY_LOG = '/patient/audit/getWoundAssessmentLog';
export const ADT_EVENTS_ACTIVITY_LOG = '/patient/audit/getPatientLog';
export const VIEW_EVENTS_ACTIVITY_LOG = '/patient/audit/getPatientAuditActivityLog';
export const CHECK_CUSTOMER_NUMBER = '/facilities';
export const OPTION_TYPES = '/listoptions'
export const MATERIALS = '/materials'
export const REGISTER_TEMP_PASSWORD = '/registration/temporarypassword'
export const REGISTER_PATIENT_FOR_MOBILE = '/registerpatientuser'
export const GET_ASSESSMENT_HISTORY = '/patients/{0}/assessments/{1}/followuphistory';
export const DELETE_HISTORY_ASSESSMENT = '/patients/{0}/assessments/{1}/followuphistory/{2}';
export const CREATE_ASSESSMENT = '/patients/{0}/assessments';
export const CREATE_PATIENT_WOUND_IMAGE = '/patient/wound/image';
export const GET_ADDITIONAL_PHOTOS = '/patient/wound/measurements/supportimage';
export const UPLOAD_ADDITIONAL_PHOTOS = '/patient/wound/measurements/support/image';
export const GET_WOUND_MEASUREMENTS = '/patient/wound/getmeasurements';
export const GET_DOWNLOAD_CONSOLIDATE_PDF = '/patient/assessment/consolidate/pdf';
export const DELETE_TEMP_CONSOLIDATE_PDF = '/patient/assessment/temp/consolidate/pdf';
export const REFUSAL_REASON = '/patient/wound/refusal/assessment'
export const CUSTOMER = '/customers';
export const CUSTOMERONE='/customer';
export const GET_FACILITY_INTEGRATION = '/customer/{0}/integration';
export const USER = '/users';
export const SSO = '/getssotenantmappinglist'; /* SSO Feature */
export const USERPENDLOCK = '/pendingreviewandlockedusers'; /* Pending & Locked Button */ 
export const FORMULARY = '/formulary';
export const DELETE_PATIENTS = '/patients/{0}';
export const DELETE_CUSTOMERS = '/customers/{0}';
export const DELETE_USERS = '/users/{0}';
export const DELETE_SSO = '/deletessotenantmapping/{0}'; // sso
export const DELETE_FORMULARIES = '/formulary/{0}';
export const APP_DOWNLOAD_INVITE = '/appdownloadinvite';
export const UPLOAD_CUSTOMER_FILE = '/bulk/customers';
export const UPLOAD_USER_FILE = '/bulk/users';
export const ANNOUNCEMENT = '/announcements';
export const DELETE_ANNOUNCEMENTS = '/announcements/{0}';
export const CUSTOM_FORM_LIST = '/forms'
export const DELETE_FORM = '/forms/{0}';
export const CREATE_FORM = '/forms/{0}';
export const NOTIFICATION = '/notifications';
export const DELETE_NOTIFICATION = '/notifications/{0}';
export const NOTIFICATION_MARK_AS_READ = '/notifications/markasread';
export const NOTIFICATION_MARK_AS_UNREAD = '/notifications/markasunread';
export const LAYOUT = '/layouts';
export const LAYOUT_DETAIL = '/layouts/{0}';
export const NEW_LAYOUT = '/layouts';
export const DELETE_LAYOUT = '/layouts/{0}';
export const CUSTOM_FORM_LIST_VIEW = '/customforms';
//export const NEW_ADMISSION_POA = '/worklists/newadmissions/pendingwoundphotopoa';
export const NEW_ADMISSION_POA = '/worklists/newadmissions/pendingwoundphotopoav1';//Version1
//export const NEW_ADMISSION_NON_POA = '/worklists/newadmissions/pendingwoundphotononpoa';
export const NEW_ADMISSION_NON_POA = '/worklists/newadmissions/pendingwoundphotononpoav1';//Version1
//export const NEW_WOUNDS_POA = '/worklists/newwounds/pendingassessmentpoa';
export const NEW_WOUNDS_POA = '/worklists/newwounds/pendingassessmentpoav1';//Version1
//export const NEW_WOUNDS_NON_POA = '/worklists/newwounds/pendingassessmentnonpoa';
export const NEW_WOUNDS_NON_POA = '/worklists/newwounds/pendingassessmentnonpoav1';//Version1
//export const PI_ASSESSMENT_POA = '/worklists/piassessments/pendingreviewpoa';
export const PI_ASSESSMENT_POA = '/worklists/piassessments/pendingreviewpoav1';//Version1
//export const PI_ASSESSMENT_NON_POA = '/worklists/piassessments/pendingreviewnonpoa';
export const PI_ASSESSMENT_NON_POA = '/worklists/piassessments/pendingreviewnonpoav1';//Version1
//export const OTHER_ASSESSMENT_POA = '/worklists/otherassessments/pendingreviewpoa';
export const OTHER_ASSESSMENT_POA = '/worklists/otherassessments/pendingreviewpoav1';//Version1
//export const OTHER_ASSESSMENT_NON_POA = '/worklists/otherassessments/pendingreviewnonpoa';
export const OTHER_ASSESSMENT_NON_POA = '/worklists/otherassessments/pendingreviewnonpoav1';//Version1
//export const WOUND_EXPERT_ASSESSMENT_POA = '/worklists/woundexpertassessments/pipoa';
export const WOUND_EXPERT_ASSESSMENT_POA = '/worklists/woundexpertassessments/pipoav1';//Version1
//export const WOUND_EXPERT_ASSESSMENT_NON_POA = '/worklists/woundexpertassessments/pinonpoa';
export const WOUND_EXPERT_ASSESSMENT_NON_POA = '/worklists/woundexpertassessments/pinonpoav1';//Version1
//export const WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT = '/worklists/woundexpertassessments/debridement';
export const WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT = '/worklists/woundexpertassessments/debridementv1';//Version1

/* SSO Access Configuration (claim-grammar resolver) */
/* The domain list. Every endpoint below is keyed on an ssoDomainId and this is the only
   thing that produces one; the legacy list navigates with an SSOTenantMappingId. */
export const GET_SSO_DOMAINS = '/getssodomains';
/* Creating the domain row on its own. The legacy New button creates one too, but only as a
   side effect of writing a legacy grant rule, which a grammar-resolved domain must not have. */
export const CREATE_SSO_DOMAIN = '/createssodomain';
export const GET_SSO_CLAIM_CONFIG = '/getssoclaimconfig/{0}';
export const UPDATE_SSO_CLAIM_CONFIG = '/updatessoclaimconfig';
export const GET_SSO_SITE_CODES = '/getssositecodes/{0}';
export const CREATE_SSO_SITE_CODE = '/createssositecode';
export const UPDATE_SSO_SITE_CODE = '/updatessositecode';
export const DELETE_SSO_SITE_CODE = '/deletessositecode/{0}';
export const GET_SSO_QUALIFIERS = '/getssoqualifiers/{0}';
export const CREATE_SSO_QUALIFIER = '/createssoqualifier';
export const UPDATE_SSO_QUALIFIER = '/updatessoqualifier';
export const DELETE_SSO_QUALIFIER = '/deletessoqualifier/{0}';
export const GET_SSO_VALUE_MAPPINGS = '/getssovaluemappings/{0}';
export const CREATE_SSO_VALUE_MAPPING = '/createssovaluemapping';
export const UPDATE_SSO_VALUE_MAPPING = '/updatessovaluemapping';
export const DELETE_SSO_VALUE_MAPPING = '/deletessovaluemapping/{0}';
export const GET_SSO_LOGIN_RESOLUTIONS = '/getssologinresolutions';
export const GET_SSO_LOGIN_RESOLUTION = '/getssologinresolution/{0}';
export const GET_SSO_OBSERVED_CLAIMS = '/getssoobservedclaims/{0}';
export const SSO_RESOLVER_TEST = '/ssoresolvertest';
export const GET_USERS_PENDING_APPROVAL = '/getuserspendingapproval';
export const APPROVE_PENDING_USER = '/approvependinguser';

/* Self-service exit from the registration pending state. Authenticated by the scope-limited
   pending token the login response returns, not by a session. */
export const REGISTRATION_ACCOUNT_NUMBER = '/v1/registration/accountnumber';

/* SSO resolver enums, mirrors Section 7 of SSO_REGISTRATION_REVIEW_AND_TARGET_DESIGN.md */
export const SSO_RESOLVER_MODES = {
  LegacyOnly: 'LegacyOnly',
  Shadow: 'Shadow',
  LegacyThenGrammar: 'LegacyThenGrammar',
  GrammarOnly: 'GrammarOnly',
};
export const SSO_RESOLVER_MODE_COPY = {
  LegacyOnly: 'Exact mapping row, then the FirstOrDefault() fallback. This is current production, including the defect that silently grants the lowest-id row to every unmatched claim.',
  Shadow: 'Legacy decides, the grammar is evaluated and recorded alongside it. Nothing a user sees changes. Start here.',
  LegacyThenGrammar: 'Exact mapping row wins if there is one. Grammar handles what the fallback used to swallow. Nothing resolves, nothing is granted.',
  GrammarOnly: "After the mapping table is retired. Only move here once the compatibility report has been clean for a full billing cycle.",
};
export const SSO_CLAIM_SHAPES = { scalar: 'scalar', array: 'array', delimited: 'delimited' };
export const SSO_EXTRACT_MODES = { none: 'none', cnFromDn: 'cnFromDn', regex: 'regex', stripPrefix: 'stripPrefix' };
export const SSO_CLAIM_MODES = {
  deptTitle: 'Department and/or title matched to a configured row',
  tenantMatch: 'Tenant matched to a configured row',
  passThrough: 'Tenant passed through verbatim, no lookup',
};
export const SSO_SCOPE_POLICIES = { none: 'None', allSitesInLine: 'AllSitesInServiceLine', allFacilitiesInGroup: 'AllFacilitiesInPrimaryGroup' };
export const SSO_QUALIFIER_WIDEN = {
  none: { key: 'none', label: 'No effect - site codes alone decide' },
  line: { key: 'line', label: 'Widen to all sites in the named service line' },
  group: { key: 'group', label: 'Widen to every facility in the primary group' },
};
export const SSO_MATCHER_TYPES = ['group', 'department', 'title', 'departmentAndTitle', 'tenant', 'explicitFacility'];
export const SSO_PENDING_REASONS = { NoDepartmentMatch: 'NoDepartmentMatch', NoFacilityClaim: 'NoFacilityClaim', DomainNotMapped: 'DomainNotMapped', AccountNumberTooBroad: 'AccountNumberTooBroad' };
export const SSO_PENDING_ORIGINS = { SelfRegistration: 'SelfRegistration', SSO: 'SSO' };
//export const COMPLETED_ASSESSMENT = '/worklists/completedassessments';
export const COMPLETED_ASSESSMENT = '/worklists/completedassessmentsv1';//Version1
export const LIST_VIEW_MENUS = '/listviewmenus';
export const MARKETING_BANNER_DETAIL = '/layouts/{0}/marketingbanners';
export const DELETE_MARKETING_BANNER = '/layouts/{0}/marketingbanners/{1}';
export const MARKETING_BANNER_CREATE = '/layouts/{0}/marketingbanners';
export const MARKETING_BANNER_UPDATE = '/layouts/{0}/marketingbanners/{1}';
export const SUPPORT_LIST = '/support';
export const SALES_OFFICE_OPTION = '/listoptions'
export const UPDATE_PASSWORD = '/updatepassword';
export const UPDATE_PROFILE_UPDATE = '/updateprofile';
export const CUSTOM_FORM_VIEW = '/customformdata/{0}';
export const GET_RISK_ASSESSMENTS = '/patients/{0}/riskassessments';
export const CUSTOMER_SEARCH_FORMULARITY_URL = '/listoptions/formulary';
export const ASSIGN_FORMULARY_CUSTOMER = '/customers/{0}/assignformulary';
export const ASSIGNED_FORMULARY = '/formulary';
export const PRODUCT = '/products';
export const DELETE_PRODUCTS = '/products/material/{0}';
export const SPECIFICATION_PRODUCTS = '/products/material/{0}/specification';
export const COMPETITORS_PRODUCTS = '/products/productfamily/{0}/competitor';
export const MARKETTING_PRODUCTS = '/products/productfamily/{0}/marketing';
export const GET_AUTO_MEASUREMENT_STATUS = '/patients/{0}/assessments/{1}/measurementstatus';
export const UPDATE_PRODUCTS_FAMILY = '/products/productfamily/{0}/basicinfo';
export const UPDATE_MATERIAL = '/products/material/{0}/basicinfo';
export const PATIENTVIEWPASTWOUND = '/patients/{0}/pastwound/assessments';
export const PATIENTVIEWDELETE = '/patientview/{0}/woundphoto/{1}';
export const DELETE_ASSESSMENT_NOTE = '/patients/{0}/assessments/{1}/notes/{2}';
//export const WOUND_PHOTO_WORKLIST = '/worklists/patientview/woundphoto'
export const WOUND_PHOTO_WORKLIST = '/worklists/patientview/woundphotov1'
export const DASHBOARD = '/dashboard';
export const REPORT_DASHBOARD = "/api/v2/reporting/dashboard";
export const DASHBOARD_WOUNDASSESSMENT = '/api/v2/reporting/dashboard/worklist';
export const DASHBOARD_WOUNDASSESSMENT_OVERVIEW = '/api/v2/reporting/dashboard/worklist/overview';//woundDashboard overview data
export const DASHBOARD_ANALYTICS = '/analytics';
export const TREATMENT_REPORT = '/api/v2/reporting/treatment';
export const DASHBOARD_TREAMENTOUTCOME_ASSESSMENT = '/api/v2/reporting/treatment/worklist'
export const QUALITY_ASSURANCE_REPORT = '/api/v2/reporting/quality-assurance';
export const DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT = '/api/v2/reporting/quality-assurance/worklist'
export const DASHBOAD_QUALITY_ASSURANCE_ASSESSMENT_OVERVIEW = '/api/v2/reporting/quality-assurance/worklist/overview' //QA overview data
export const DASHBOARD_ADHOC_REPORT = '/api/v2/reporting/adhoc/Dashboard';
export const WOUND_WORKLIST_COUNT = '/worklists/recordscount'
//export const REG_PRIRIMARY_CUSTOMER= '/registeruser/primarycustomer';
export const REG_PRIRIMARY_CUSTOMER= '/registeruser/v1/primarycustomer';
export const REG_USER_WITH_FACILITY= '/v1/registeruserwithfacility';
//export const REG_USER_WITH_FACILITY= '/v2/registeruserwithfacility';//api version changes
export const REG_ORG_TYPE= '/registeruser/organizationtype';
//app storage keys
export const SIGNIN_TOKEN = 'signin_token';
export const ROLES = '/roles'
export const VERIFYUSEREMAIL = '/v2/verifyuseremail'
//regex
//export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//export const EMAIL_REGEX = /^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\,;:!#$%+?*/\={}|"~^&\s@"]+(\.[^<>()[\]\\.,;:!#$%+?*/\={}|"~^&\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PHONE_MASK_REGEX = /(\d{3})(\d{3})(\d{4})/;
export const ALPHA_NUMERIC = /^[a-zA-Z0-9]*$/;
export const ALPHA_NUMERIC_CUSTOMFORM = /^[\w ]+$/i;

//api status
export const SUCCESS_STATUS = 'success'; 
export const ERROR_STATUS = 'error';

//Date Format
export const DATE_FORMAT = 'MM/dd/yyyy';
export const CURRENT_DATE = new Date();

//US States array
export const US_STATES = [
    // { value: 'Select', key: null},
    { value: 'AL-Alabama', key: 'AL'},
    { value: 'AK-Alaska', key: 'AK'},
    { value: 'AZ-Arizona', key: 'AZ'},
    { value: 'AR-Arkansas', key: 'AR'},
    { value: 'CA-California', key: 'CA'},
    { value: 'CO-Colorado', key: 'CO'},
    { value: 'CT-Connecticut', key: 'CT'},
    { value: 'DE-Delaware', key: 'DE'},
    { value: 'FL-Florida', key: 'FL'},
    { value: 'GA-Georgia', key: 'GA'},
    { value: 'HI-Hawaii', key: 'HI'},
    { value: 'ID-Idaho', key: 'ID'},
    { value: 'IL-Illinois', key: 'IL'},
    { value: 'IN-Indiana', key: 'IN'},
    { value: 'IA-Iowa', key: 'IA'},
    { value: 'KS-Kansas', key: 'KS'},
    { value: 'KY-Kentucky', key: 'KY'},
    { value: 'LA-Louisiana', key: 'LA'},
    { value: 'ME-Maine', key: 'ME'},
    { value: 'MD-Maryland', key: 'MD'},
    { value: 'MA-Massachusetts', key: 'MA'},
    { value: 'MI-Michigan', key: 'MI'},
    { value: 'MN-Minnesota', key: 'MN'},
    { value: 'MS-Mississippi', key: 'MS'},
    { value: 'MO-Missouri', key: 'MO'},
    { value: 'MT-Montana', key: 'MT'},
    { value: 'NE-Nebraska', key: 'NE'},
    { value: 'NV-Nevada', key: 'NV'},
    { value: 'NH-New Hampshire', key: 'NH'},
    { value: 'NJ-New Jersey', key: 'NJ'},
    { value: 'NM-New Mexico', key: 'NM'},
    { value: 'NY-New York', key: 'NY'},
    { value: 'NC-North Carolina', key: 'NC'},
    { value: 'ND-North Dakota', key: 'ND'},
    { value: 'OH-Ohio', key: 'OH'},
    { value: 'OK-Oklahoma', key: 'OK'},
    { value: 'OR-Oregon', key: 'OR'},
    { value: 'PA-Pennsylvania', key: 'PA'},
    { value: 'RI-Rhode Island', key: 'RI'},
    { value: 'SC-South Carolina', key: 'SC'},
    { value: 'SD-South Dakota', key: 'SD'},
    { value: 'TN-Tennessee', key: 'TN'},
    { value: 'TX-Texas', key: 'TX'},
    { value: 'UT-Utah', key: 'UT'},
    { value: 'VT-Vermont', key: 'VT'},
    { value: 'VA-Virginia', key: 'VA'},
    { value: 'WA-Washington', key: 'WA'},
    { value: 'WV-West Virginia', key: 'WV'},
    { value: 'WI-Wisconsin', key: 'WI'},
    { value: 'WY-Wyoming', key: 'WY'}
]

export const CA_STATES = [
//  { value: 'Select', key: null},
 { value: 'AB-Alberta', key: 'AB'},
 { value: 'BC-British Columbia', key: 'BC'},
 { value: 'MB-Manitoba', key: 'MB'},
 { value: 'NB-New Brunswick', key: 'NB'},
 { value: 'NL-Newfoundland and Labrador', key: 'NL'},
 { value: 'NT-Northwest Territories', key: 'NT'},
 { value: 'NS-Nova Scotia', key: 'NS'},
 { value: 'NU-Nunavut', key: 'NU'},
 { value: 'ON-Ontario', key: 'ON'},
 { value: 'PE-Prince Edward Island', key: 'PE'},
 { value: 'QC-Quebec', key: 'QC'},
 { value: 'SK-Saskatchewan', key: 'SK'},
 { value: 'YT-Yukon', key: 'YT'}
] 

/**************************
 * PATIENTS SECTION
 **************************/

export const DISCHARGED = 'discharged';
export const BWAT = 'bwat'
export const PUSH = 'push'
export const COMORBID = ['Dementia', 'Osteoarthritis', 'Coronary artery disease', 'Visual Impairment(Documented)',
    'Chronic obstructive pulmonary disease', 'Depression', 'Type 2 diabetes mellitus', 'Hearing impairment(documented)',
    'Weight loss(documented)', 'Peripheral artery disease', 'Heart failure', 'Atrial fibrillation', 'Chronic kidney disease']

export const INSURANCE_PAYER = ['Medicare Part A', 'Medicare Part B', 'Medicaid', 'Anthem', 'Centere',
    'Humana', 'HCSC', 'CVS Health', 'MCNA Health Care', 'Kaiser Permaanente', 'Molina Healthcare',
    'Emblem Health', 'Highmark', 'IHC Inc.', 'Wellmark Inc.', 'Common Ground Healthcare Corp.',
    'TRICARE', 'Aetna', 'Cigna', 'United Healthcare', 'Blue Cross Blue Shield',
    'Independence Blue Cross', 'Tufts', 'Carefirst Inc.']

/* Patients related constats */

export const PATIENT_GENDER = { female: 'Female', male: 'Male', other: 'Other', unknown: 'Unknown' }
//export const PATIENT_PHONE_TYPE = { cell: 'Cell', landline: 'Landline' }
export const PATIENT_PHONE_TYPE = { cell: 'Cell', home: 'Home', work: 'Work' }
export const PATIENT_DIABETIC = { 0: 'No', 1: 'Yes' }
export const PATIENT_SMOKING_STATUS = { 0: 'No', 1: 'Yes' }
export const PATIENT_NE1_WMS_STATUS = { 0: 'Inactive', 1: 'Active' }

export const USER_REGISTRATION_PATHS = ['/login', '/registration', '/registration/accountnumber', '/resetpassword', '/forgotpassword', '/useractivation', '/updatepassword'];

export const ACCOUNT_GROUP_CODE = [
    {
        key: 'Z002',
        value: 'Z002 - Primary Group'
    },
    {
        key: '0001',
        value: '0001 - Sold_To'
    },
    {
        key: '0002',
        value: '0002 - Ship_To'
    },
]
export const CUSTOMER_GROUP_NAME = [
    {
        key: 'criticalAccess',
        value: 'Critical access'
    },
    {
        key: 'homeHealthAgency',
        value: 'Home health agency'
    },
    {
        key: 'hospice',
        value: 'Hospice'
    },
    {
        key: 'hospital',
        value: 'Hospital'
    },
    {
        key: 'nursingHome',
        value: 'Nursing Home'
    },
    {
        key: 'paceProgram',
        value: 'Pace Program'
    },
    {
        key: 'podiatry',
        value: 'Podiatry'
    },
    {
        key: 'rehabhospitalLTAC',
        value: 'Rehab hospital/ LTAC'
    },
    {
        key: 'woundCareCenter',
        value: 'Wound Care Center'
    },

]
export const LIST_VIEW_LIMIT = process.env.REACT_APP_LIST_VIEW_LIMIT || 50
export const CUSTOMER_DEVICE_TYPE_CONDITIONS = [
    {
        key: 'appleIpad',
        value: 'Apple IPad'
    },
    {
        key: 'appleIphone',
        value: 'Apple iPhone'
    },
    {
        key: 'appleIpod',
        value: 'Apple iPod'
    },
    {
        key: 'androidTablet',
        value: 'Android Tablet'
    },
    {
        key: 'androidPhone',
        value: 'Android Phone'
    },

]

export const CUSTOMER_WOUND_FREQUENCY_CONDITIONS = [
    {
        key: "Daily",
        value: "Daily"
    },
    {
        key: "Every 2 days",
        value: "Every 2 days"
    },
    {
        key: "Every 3 days",
        value: "Every 3 days"
    },
    {
        key: "Weekly",
        value: "Weekly"
    },
    {
        key: "Bi-weekly",
        value: "Bi-weekly"
    },
    {
        key: "Monthly",
        value: "Monthly"
    }
]
export const CUSTOMER_EMR_CONDITIONS = [
    {
        key: "Epic",
        value: "Epic"
    },
    {
        key: "Cerner",
        value: "Cerner"
    },
    {
        key: "Allscripts",
        value: "Allscripts"
    },
    {
        key: "Athenahealth",
        value: "Athenahealth"
    },
    {
        key: "MEDITECH",
        value: "MEDITECH"
    },
    {
        key: "Netsmart Technologies",
        value: "Netsmart Technologies"
    }
    ,
    {
        key: "Brightree",
        value: "Brightree"
    },
    {
        key: "NetHealth",
        value: "NetHealth"
    },
    {
        key: "Casamba (Healthwyse)",
        value: "Casamba (Healthwyse)"
    }


]

export const WOC_ON_STAFF_STATUS = { 0: 'No', 1: 'Yes' }

export const NE1_RULER_MEASUREMENTS = { 0: 'No', 1: 'Yes' }

/*Get Country code options*/

export const COUNTRY_CODE_OPTIONS = [{ value: 'United States', key: 'US'}, { value: 'Canada', key: 'CA' }]

// export const COUNTRY_CODE_OPTIONS = [{ value: 'Afghanistan', key: 'AF' }, { value: 'Aland Islands', key: 'AX' },
// { value: 'Albania', key: 'AL' }, { value: 'Algeria', key: 'DZ' }, { value: 'American Samoa', key: 'AS' },
// { value: 'AndorrA', key: 'AD' }, { value: 'Angola', key: 'AO' }, { value: 'Anguilla', key: 'AI' },
// { value: 'Antarctica', key: 'AQ' }, { value: 'Antigua and Barbuda', key: 'AG' },
// { value: 'Argentina', key: 'AR' }, { value: 'Armenia', key: 'AM' },
// { value: 'Aruba', key: 'AW' }, { value: 'Australia', key: 'AU' },
// { value: 'Austria', key: 'AT' }, { value: 'Azerbaijan', key: 'AZ' },
// { value: 'Bahamas', key: 'BS' }, { value: 'Bahrain', key: 'BH' },
// { value: 'Bangladesh', key: 'BD' }, { value: 'Barbados', key: 'BB' },
// { value: 'Belarus', key: 'BY' }, { value: 'Belgium', key: 'BE' },
// { value: 'Belize', key: 'BZ' }, { value: 'Benin', key: 'BJ' },
// { value: 'Bermuda', key: 'BM' }, { value: 'Bhutan', key: 'BT' },
// { value: 'Bolivia', key: 'BO' }, { value: 'Bosnia and Herzegovina', key: 'BA' },
// { value: 'Botswana', key: 'BW' }, { value: 'Bouvet Island', key: 'BV' },
// { value: 'Brazil', key: 'BR' }, { value: 'British Indian Ocean Territory', key: 'IO' },
// { value: 'Brunei Darussalam', key: 'BN' }, { value: 'Bulgaria', key: 'BG' },
// { value: 'Burkina Faso', key: 'BF' }, { value: 'Burundi', key: 'BI' },
// { value: 'Cambodia', key: 'KH' }, { value: 'Cameroon', key: 'CM' },
// { value: 'Canada', key: 'CA' }, { value: 'Cape Verde', key: 'CV' },
// { value: 'Cayman Islands', key: 'KY' }, { value: 'Central African Republic', key: 'CF' },
// { value: 'Chad', key: 'TD' }, { value: 'Chile', key: 'CL' }, { value: 'China', key: 'CN' },
// { value: 'Christmas Island', key: 'CX' }, { value: 'Cocos (Keeling) Islands', key: 'CC' },
// { value: 'Colombia', key: 'CO' }, { value: 'Comoros', key: 'KM' }, { value: 'Congo', key: 'CG' },
// { value: 'Congo, The Democratic Republic of the', key: 'CD' }, { value: 'Cook Islands', key: 'CK' },
// { value: 'Costa Rica', key: 'CR' }, { value: 'Cote D\'Ivoire', key: 'CI' }, { value: 'Croatia', key: 'HR' },
// { value: 'Cuba', key: 'CU' }, { value: 'Cyprus', key: 'CY' }, { value: 'Czech Republic', key: 'CZ' },
// { value: 'Denmark', key: 'DK' }, { value: 'Djibouti', key: 'DJ' }, { value: 'Dominica', key: 'DM' },
// { value: 'Dominican Republic', key: 'DO' }, { value: 'Ecuador', key: 'EC' }, { value: 'Egypt', key: 'EG' },
// { value: 'El Salvador', key: 'SV' }, { value: 'Equatorial Guinea', key: 'GQ' }, { value: 'Eritrea', key: 'ER' },
// { value: 'Estonia', key: 'EE' }, { value: 'Ethiopia', key: 'ET' }, { value: 'Falkland Islands (Malvinas)', key: 'FK' },
// { value: 'Faroe Islands', key: 'FO' }, { value: 'Fiji', key: 'FJ' }, { value: 'Finland', key: 'FI' }, { value: 'France', key: 'FR' },
// { value: 'French Guiana', key: 'GF' }, { value: 'French Polynesia', key: 'PF' }, { value: 'French Southern Territories', key: 'TF' },
// { value: 'Gabon', key: 'GA' }, { value: 'Gambia', key: 'GM' }, { value: 'Georgia', key: 'GE' }, { value: 'Germany', key: 'DE' },
// { value: 'Ghana', key: 'GH' }, { value: 'Gibraltar', key: 'GI' }, { value: 'Greece', key: 'GR' }, { value: 'Greenland', key: 'GL' },
// { value: 'Grenada', key: 'GD' }, { value: 'Guadeloupe', key: 'GP' }, { value: 'Guam', key: 'GU' }, { value: 'Guatemala', key: 'GT' },
// { value: 'Guernsey', key: 'GG' }, { value: 'Guinea', key: 'GN' }, { value: 'Guinea-Bissau', key: 'GW' }, { value: 'Guyana', key: 'GY' },
// { value: 'Haiti', key: 'HT' }, { value: 'Heard Island and Mcdonald Islands', key: 'HM' },
// { value: 'Holy See (Vatican City State)', key: 'VA' }, { value: 'Honduras', key: 'HN' }, { value: 'Hong Kong', key: 'HK' },
// { value: 'Hungary', key: 'HU' }, { value: 'Iceland', key: 'IS' }, { value: 'India', key: 'IN' }, { value: 'Indonesia', key: 'ID' },
// { value: 'Iran, Islamic Republic Of', key: 'IR' }, { value: 'Iraq', key: 'IQ' }, { value: 'Ireland', key: 'IE' },
// { value: 'Isle of Man', key: 'IM' }, { value: 'Israel', key: 'IL' }, { value: 'Italy', key: 'IT' }, { value: 'Jamaica', key: 'JM' },
// { value: 'Japan', key: 'JP' }, { value: 'Jersey', key: 'JE' }, { value: 'Jordan', key: 'JO' }, { value: 'Kazakhstan', key: 'KZ' },
// { value: 'Kenya', key: 'KE' }, { value: 'Kiribati', key: 'KI' }, { value: 'Korea, Democratic People\'S Republic of', key: 'KP' },
// { value: 'Korea, Republic of', key: 'KR' }, { value: 'Kuwait', key: 'KW' }, { value: 'Kyrgyzstan', key: 'KG' },
// { value: 'Lao People\'S Democratic Republic', key: 'LA' }, { value: 'Latvia', key: 'LV' }, { value: 'Lebanon', key: 'LB' },
// { value: 'Lesotho', key: 'LS' }, { value: 'Liberia', key: 'LR' }, { value: 'Libyan Arab Jamahiriya', key: 'LY' },
// { value: 'Liechtenstein', key: 'LI' }, { value: 'Lithuania', key: 'LT' }, { value: 'Luxembourg', key: 'LU' },
// { value: 'Macao', key: 'MO' }, { value: 'Macedonia, The Former Yugoslav Republic of', key: 'MK' }, { value: 'Madagascar', key: 'MG' },
// { value: 'Malawi', key: 'MW' }, { value: 'Malaysia', key: 'MY' }, { value: 'Maldives', key: 'MV' }, { value: 'Mali', key: 'ML' },
// { value: 'Malta', key: 'MT' }, { value: 'Marshall Islands', key: 'MH' }, { value: 'Martinique', key: 'MQ' }, { value: 'Mauritania', key: 'MR' },
// { value: 'Mauritius', key: 'MU' }, { value: 'Mayotte', key: 'YT' }, { value: 'Mexico', key: 'MX' },
// { value: 'Micronesia, Federated States of', key: 'FM' }, { value: 'Moldova, Republic of', key: 'MD' }, { value: 'Monaco', key: 'MC' },
// { value: 'Mongolia', key: 'MN' }, { value: 'Montserrat', key: 'MS' }, { value: 'Morocco', key: 'MA' }, { value: 'Mozambique', key: 'MZ' },
// { value: 'Myanmar', key: 'MM' }, { value: 'Namibia', key: 'NA' }, { value: 'Nauru', key: 'NR' }, { value: 'Nepal', key: 'NP' },
// { value: 'Netherlands', key: 'NL' }, { value: 'Netherlands Antilles', key: 'AN' }, { value: 'New Caledonia', key: 'NC' },
// { value: 'New Zealand', key: 'NZ' }, { value: 'Nicaragua', key: 'NI' }, { value: 'Niger', key: 'NE' }, { value: 'Nigeria', key: 'NG' },
// { value: 'Niue', key: 'NU' }, { value: 'Norfolk Island', key: 'NF' }, { value: 'Northern Mariana Islands', key: 'MP' },
// { value: 'Norway', key: 'NO' }, { value: 'Oman', key: 'OM' }, { value: 'Pakistan', key: 'PK' }, { value: 'Palau', key: 'PW' },
// { value: 'Palestinian Territory, Occupied', key: 'PS' }, { value: 'Panama', key: 'PA' }, { value: 'Papua New Guinea', key: 'PG' },
// { value: 'Paraguay', key: 'PY' }, { value: 'Peru', key: 'PE' }, { value: 'Philippines', key: 'PH' }, { value: 'Pitcairn', key: 'PN' },
// { value: 'Poland', key: 'PL' }, { value: 'Portugal', key: 'PT' }, { value: 'Puerto Rico', key: 'PR' }, { value: 'Qatar', key: 'QA' },
// { value: 'Reunion', key: 'RE' }, { value: 'Romania', key: 'RO' }, { value: 'Russian Federation', key: 'RU' }, { value: 'RWANDA', key: 'RW' }, 
// { value: 'Saint Helena', key: 'SH' }, { value: 'Saint Kitts and Nevis', key: 'KN' }, { value: 'Saint Lucia', key: 'LC' }, { value: 'Saint Pierre and Miquelon', key: 'PM' }, { value: 'Saint Vincent and the Grenadines', key: 'VC' }, { value: 'Samoa', key: 'WS' }, { value: 'San Marino', key: 'SM' }, { value: 'Sao Tome and Principe', key: 'ST' }, { value: 'Saudi Arabia', key: 'SA' }, { value: 'Senegal', key: 'SN' }, { value: 'Serbia and Montenegro', key: 'CS' }, { value: 'Seychelles', key: 'SC' }, { value: 'Sierra Leone', key: 'SL' }, { value: 'Singapore', key: 'SG' }, { value: 'Slovakia', key: 'SK' }, { value: 'Slovenia', key: 'SI' }, { value: 'Solomon Islands', key: 'SB' }, { value: 'Somalia', key: 'SO' }, { value: 'South Africa', key: 'ZA' }, { value: 'South Georgia and the South Sandwich Islands', key: 'GS' }, { value: 'Spain', key: 'ES' }, { value: 'Sri Lanka', key: 'LK' }, { value: 'Sudan', key: 'SD' }, { value: 'Suriname', key: 'SR' }, { value: 'Svalbard and Jan Mayen', key: 'SJ' }, { value: 'Swaziland', key: 'SZ' }, { value: 'Sweden', key: 'SE' }, { value: 'Switzerland', key: 'CH' }, { value: 'Syrian Arab Republic', key: 'SY' }, { value: 'Taiwan, Province of China', key: 'TW' }, { value: 'Tajikistan', key: 'TJ' }, { value: 'Tanzania, United Republic of', key: 'TZ' }, { value: 'Thailand', key: 'TH' }, { value: 'Timor-Leste', key: 'TL' }, { value: 'Togo', key: 'TG' }, { value: 'Tokelau', key: 'TK' }, { value: 'Tonga', key: 'TO' }, { value: 'Trinidad and Tobago', key: 'TT' }, { value: 'Tunisia', key: 'TN' }, { value: 'Turkey', key: 'TR' }, { value: 'Turkmenistan', key: 'TM' }, { value: 'Turks and Caicos Islands', key: 'TC' }, { value: 'Tuvalu', key: 'TV' }, { value: 'Uganda', key: 'UG' }, { value: 'Ukraine', key: 'UA' }, { value: 'United Arab Emirates', key: 'AE' }, { value: 'United Kingdom', key: 'GB' }, { value: 'United States', key: 'US' }, { value: 'United States Minor Outlying Islands', key: 'UM' }, { value: 'Uruguay', key: 'UY' }, { value: 'Uzbekistan', key: 'UZ' }, { value: 'Vanuatu', key: 'VU' }, { value: 'Venezuela', key: 'VE' }, { value: 'Viet Nam', key: 'VN' }, { value: 'Virgin Islands, British', key: 'VG' }, { value: 'Virgin Islands, U.S.', key: 'VI' }, { value: 'Wallis and Futuna', key: 'WF' }, { value: 'Western Sahara', key: 'EH' }, { value: 'Yemen', key: 'YE' }, { value: 'Zambia', key: 'ZM' }, { value: 'Zimbabwe', key: 'ZW' }]

/*Get Role option*/
export const ROLE_OPTIONS = [
    { value: 'External Administrator', key: 'eXTAdministrator' },
    { value: 'External Super User', key: 'eXTSuperUser' },
    { value: 'External Standard User', key: 'eXTStandardUser' },
    { value: 'External Executive', key: 'eXTExecutive' },
    { value: 'External Wound Specialist', key: 'eXTWoundSpecialist' },
    { value: 'External Nurse Level 1', key: 'eXTNurseLevel1' },
    { value: 'External Nurse Level 2', key: 'eXTNurseLevel2' },
    { value: 'External Nurse Level 3', key: 'eXTNurseLevel3' },
    { value: 'External Physicians', key: 'eXTPhysicians' },
    { value: 'External Nurse Aide', key: 'eXTNurseAide' },
    { value: 'Sale Rep', key: 'saleRep' },
    { value: 'Administrator', key: 'administrator' },
    { value: 'Super User', key: 'superUser' },
    { value: 'Standard User', key: 'standardUser' },
    { value: 'Executive', key: 'executive' },
    { value: 'Wound Specialist', key: 'woundSpecialist' },
    { value: 'Nurse', key: 'nurse' },
    { value: 'Help Desk', key: 'helpDesk' },
    { value: 'Content Author', key: 'contentAuthor' },
    { value: 'Regulatory', key: 'regulatory' }
]

export const DOMAIN_REGEX = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;

export const HISTORY_CAUSE = [
    {
        key: 'pressureInjury',
        value: 'Pressure Injury (PI)',
        child: [
            {
                key: 'poormobilitypressureinjuryulcer',
                value: 'Poor Mobility Pressure Injury/Ulcer'
            },
            {
                key: 'poorMobilityWithShearPressureInjuryUlcer',
                value: 'Poor Mobility with Shear Pressure Injury/Ulcer'
            },
            {
                key: 'deviceRelatedPressureInjuryUlcer',
                value: 'Device Related Pressure Injury/Ulcer'
            }
        ]
    },
    {
        key: 'mucosalMembranePressureInjuryUlcer',
        value: 'Mucosal Membrane Pressure Injury/Ulcer (MMPI)'
    },
    {
        key: 'other',
        value: 'Other',
        child: [
            {
                key: 'abrasion',
                value: 'Abrasion'
            },
            {
                key: 'bruise',
                value: 'Bruise'
            },
            {
                key: 'burn',
                value: 'Burn',
            },
            {
                key: 'cancerRelated',
                value: 'Cancer Related'
            },
            {
                key: 'circulationProblems',
                value: 'Circulation Problems'
            },
            {
                key: 'cutaneousManifestationOfCovid19',
                value: 'Cutaneous manifestation of COVID-19'
            },
            {
                key: 'diabetes',
                value: 'Diabetes'
            },
            {
                key: 'fallRelated',
                value: 'Fall Related'
            },
            {
                key: 'frictionRelated',
                value: 'Friction Related'
            },
            {
                key: 'incision',
                value: 'Incision'
            },
            {
                key: 'incontinentOfBowelOrBladder',
                value: 'Incontinent of bowel or bladder'
            },
            {
                key: 'laceration',
                value: 'Laceration'
            },
            {
                key: 'medicalAdhesiveRelatedSkinInjury',
                value: 'Medical Adhesive related skin injury'
            },
            {
                key: 'moistureRelatedSkinDamage',
                value: 'Moisture related skin damage'
            },
            {
                key: 'mucosalMembrance',
                value: 'Mucosal Membrane'
            },
            {
                key: 'nailsFingerToes',
                value: 'Nail(s) (Finger/Toes)'
            },
            {
                key: 'neuropathic',
                value: 'Neuropathic'
            },
            {
                key: 'ostomyRelated',
                value: 'Ostomy related'
            },
            {
                key: 'rash',
                value: 'Rash'
            },
            {
                key: 'skinTear',
                value: 'Skin Tear'
            },
            {
                key: 'traumRelated',
                value: 'Traum related'
            },
            {
                key: 'tubesAndDrains',
                value: 'Tubes and Drains'
            }
        ]
    },
    {
        key: 'unableToDetermine',
        value: 'Unable to determine'
    }
]
export const CUSTOMER_STATUS = { 0: 'false', 1: 'true' }
export const AI_TISSUE_TYPE_STATUS = { 0: 'Disable', 1: 'Enable' }
export const CUSTOMER_NE1_WMS_STATUS = { 0: 'Disable', 1: 'Enable' }
export const INTERNAL_ADMINISTRATOR = 'MedlineAdministrator';
export const USER_MANAGE_STATUS = { 0: 'Inactive', 1: 'Active' }
export const USER_EMAIL_STATUS = { 1 : 'Verified', 0: 'Not verified'} //added
export const WOUND_EDGE_AUTO_TRACING_STATUS = { 0: 'Disable', 1: 'Enable' }
export const NE1_WOUND_MEASUREMENT_OPT = { 0: 'Head to Toe', 1: 'Longest length' }
export const ENABLE_DISABLE_STATUS = { 0: 'Disable', 1: 'Enable' }
export const YES_NO_STATUS = { 0: 'No', 1: 'Yes' }

export const SALES_OFFICE_OPTIONS = [
    { value: 'All Customers', key: 'both' },
    { value: 'Acute Customers', key: 'acute' },
    { value: 'Post Acute Customers', key: 'postacute' },
]
export const SALES_OFFICE_OPTIONS_CUST = [
    { value: 'Acute', key: 'acute' },
    { value: 'Post Acute', key: 'postacute' }
]
//Record Created messages
export const PATIENT_CREATED_MSG = 'Patient has been successfully created!';
export const CUSTOMER_CREATED_MSG = 'Customer has been successfully created!';
export const USER_CREATED_MSG = 'User has been successfully created!';
export const SSO_CREATED_MSG = 'SSO has been successfully created!'; // sso created successfully
// export const ANNOUNCEMENT_CREATED_MSG = 'Announcement has been successfully created!';
export const ANNOUNCEMENT_DESCRIPTION_LIMIT = 300;
export const ANNOUNCEMENT_DESCRIPTION_LIMIT_REQUIRED = "Announcement description must have limited characters only!"
export const ANNOUNCEMENT_NAME_LIMIT = 70;
export const ANNOUNCEMENT_NAME_LIMIT_REQUIRED = "Announcement name must have limited characters only!"
export const ANNOUNCEMENT_SALES_OFFICE_CHECK = { acute: 'Acute', postacute: 'Post Acute', both: 'Both' }

export const LAYOUT_CREATED_MSG = 'Layout has been successfully created!';
export const USER_PROFILE_PHDR_LIMIT = 250;
export const CARING_DESCRIPTION_LIMIT_REQUIRED = "Description must have limited characters only!"

// Assessment status
export const PENDING_REVIEW = "pendingreview"
export const PENDING_ASSESSMENT = "pendingassessment"
export const SIGNED_LOCKED = "signedlocked"

export const PHYSICAL_CONDITION_OPTIONS = [
    { value: 'Good', key: 'good' },
    { value: 'Fair', key: 'fair' },
    { value: 'Poor', key: 'poor' },
    { value: 'Very Bad', key: 'veryBad' }
]
export const MENTAL_CONDITION_OPTIONS = [
    { value: 'Alert', key: 'alert' },
    { value: 'Apathetic', key: 'apathetic' },
    { value: 'Confused', key: 'confused' },
    { value: 'Stuporous', key: 'stuporous' }
]
export const ACTIVITY_OPTIONS = [
    { value: 'Ambulant', key: 'ambulant' },
    { value: 'Walks with help', key: 'walksWithHelp' },
    { value: 'Chairbound', key: 'chairBound' },
    { value: 'Bedfast', key: 'BedFast' }
]
export const MOBILITY_OPTIONS = [
    { value: 'Full', key: 'full' },
    { value: 'Slightly Impaired', key: 'slightlyImpaired' },
    { value: 'Very Limited', key: 'veryLimited' },
    { value: 'Immobile', key: 'immobile' }
]
export const INCONTINENCE_OPTIONS = [
    { value: 'None', key: 'none' },
    { value: 'Occasional', key: 'occasional' },
    { value: 'Usually Urinary', key: 'usuallyUrinary' },
    { value: 'Urinary and Fecal', key: 'urinaryAndFecal' }
]

export const BRADEN_FORM_OPTIONS = [
    {
        "key": "noimpairment",
        value: 'No impairment',
        description: 'Responds to verbal commands. Has no sensory deficit which would limit ability to feel or voice pain or discomfort'
    },
    {
        "key": "sightlylimited",
        value: 'Slightly limited',
        description: 'Responds to verbal commands but cannot always communicate discomfort or ask to be moved or turned OR has some sensory impairment which limits the ability to feel pain or discomfort'
    },
    {
        "key": "verylimited",
        value: 'Very limited',
        description: 'Responds to verbal commands but cannot always communicate discomfort or ask to be moved or turned OR has some sensory impairment which limits the ability to feel pain or discomfort'
    },
    {
        "key": "completedlylimited",
        value: 'Completedly limited',
        description: 'Responds to verbal commands but cannot always communicate discomfort or ask to be moved or turned OR has some sensory impairment which limits the ability to feel pain or discomfort'
    },
]

export const MATERIAL_STATUS = [
    {
        key: 1,
        value: 'EMPTY'
    },
    {
        key: 2,
        value: '08 - Product discontinued with stock'
    },
    {
        key: 3,
        value: '7C - Competitive product'
    },
    {
        key: 4,
        value: '7M - Unfinished Raw Material'
    },
    {
        key: 5,
        value: '9A - Discontinued item with substitute'
    },
    {
        key: 6,
        value: '9B - Discontinued item with no substitute'
    },
    {
        key: 7,
        value: '9N - Product has been set up but not available for purchase'
    },
    {
        key: 8,
        value: '9S - Discontinued item with a surplus'
    },


]

export const PROCUCT_CATEGORY_CODE = [
    {
        key: 1,
        value: 'CA01_05_01'
    },
    {
        key: 2,
        value: 'CA10_03_02'
    },
    {
        key: 3,
        value: 'CA01_01_01'
    },
    {
        key: 4,
        value: 'CA03_09_01'
    }
]

export const PRODUCT_MANAGER = [
    {
        key: 1,
        value: 'Cory Jones'
    },
    {
        key: 2,
        value: 'Benjamin Clark'
    },
    {
        key: 3,
        value: 'Steve Dobek'
    },
    {
        key: 4,
        value: 'Brooke Silverberg'
    },
    {
        key: 5,
        value: 'Alana Schwarz'
    },
    {
        key: 6,
        value: 'Kristen Ann Fox'
    },
    {
        key: 7,
        value: 'Nicholas Morris'
    },
    {
        key: 8,
        value: 'Steven Harris'
    },
    {
        key: 9,
        value: 'Bushra Hassan'
    },
    {
        key: 10,
        value: 'Joshua Kolof'
    },
    {
        key: 11,
        value: 'Samuel Glover'
    },
    {
        key: 12,
        value: 'Grace Casey'
    },
    {
        key: 13,
        value: 'Gina Cirrincione'
    },
    {
        key: 14,
        value: 'Joseph Esch'
    },
    {
        key: 15,
        value: 'Elayne Pruckno'
    },
    {
        key: 16,
        value: 'Bree Langer'
    },
    {
        key: 17,
        value: 'Martha Roman'
    },
    {
        key: 18,
        value: 'Anna James'
    },
    {
        key: 19,
        value: 'Jacob Katz'
    },
    {
        key: 20,
        value: 'Luke Burns'
    },
    {
        key: 21,
        value: 'Alexa Chapman'
    },
    {
        key: 22,
        value: 'Drew Phalen'
    },
    {
        key: 23,
        value: 'Bridget Dever'
    },
]

//export const CUSTOMER_STATUS = { 0: 'false', 1: 'true' }

export const DIVISION_DATA = [
    "Advanced Skin Care (80)",
    "Advanced Wound Care (71)",
    "Nutrition and Pharmaceuticals (14)",
    "Repositioning and Offloading (75)",
    //"Personal Care (82)"
]

/*export const UNIT_MEASURE = [
    {
        key: 1,
        value: 'EA'
    },
    {
        key: 2,
        value: 'CS'
    },
    {
        key: 3,
        value: 'GRO'
    },
    {
        key: 4,
        value: 'PAA'
    },
    {
        key: 5,
        value: 'BX'
    },
    {
        key: 6,
        value: 'BOT'
    },
]*/

export const UNIT_MEASURE = [
    {
        key: 'EA',
        value: 'EA'
    },
    {
        key:'CS',
        value: 'CS'
    },
    {
        key: 'GRO',
        value: 'GRO'
    },
    {
        key: 'PAA',
        value: 'PAA'
    },
    {
        key: 'BX',
        value: 'BX'
    },
    {
        key: 'BOT',
        value: 'BOT'
    },
]

//Clinician Login Privacy and Terms Policy

export const PRIVACY_POLICY_URL = 'https://cms.medlinesh.com/node/263';
export const TERMS_URL = 'https://cms.medlinesh.com/node/264';

//Material Description 
export const MATERIAL_DESCRIPTION_LIMIT = 100;
export const MATERIAL_DESCRIPTION_LIMIT_REQUIRED = "Max 100 characters limit"
//Customer Settings TimeOut options 
export const SESSION_TIMEOUT_OPTIONS = [
    {
        key: '',
        value: 'Select'
    },
    {
        key: 'months',
        value: 'Months'
    },
    {
        key: 'weeks',
        value: 'Weeks'
    },
    {
        key: 'days',
        value: 'Days'
    },
    {
        key: 'hours',
        value: 'Hours'
    },
    {
        key: 'minutes',
        value: 'Minutes'
    }    
]

export const SESSION_MONTHS_LIMIT = 12;
export const SESSION_WEEKS_LIMIT = 4;
export const SESSION_DAYS_LIMIT = 7;
export const SESSION_HOURS_LIMIT = 24;
export const SESSION_MINUTES_LIMIT = 1440;

//Customer Settings POA options 
export const POA_TYPE_OPTIONS = [
    {
        key: '',
        value: 'Select'
    }
    ,
    {
        key: 'hours',
        value: 'Hours'
    },
    {
        key: 'days',
        value: 'Days'
    }
    
]

export const FORMULARY_IMPORT_METHOD=['Append: Keep existing materials and insert new materials from the file',`Replace: Remove existing materials and replace them with this file`]

//SSO 
export const SSO_CLIENT_ID = process.env.REACT_APP_SSO_CLINET_ID

export const OAUTH_HOST_URL = process.env.REACT_APP_SSO_OAUTH_URL

export const OAUTH_TOKEN_URL = 'https://clinrepodev.medline.com/oauth/v1/token'

//API RESPONSE TIME OUT SET
export const API_RESPONSE_TIMEOUT =   5* 60 * 1000 ;// 5 minutes
export const WOUND_ACQUIRED_OPTIONS = [
    { value: 'All', key: 'all' },
    { value: 'POA', key: 'poa' },
    { value: 'NON-POA', key: 'nonpoa' }
]

export const CONSOLIDATE_PDF_MAX_COUNT = 10;
export const CREATE_PATIENT_DOB_REF = "01/01/1900";

export const WOUND_ASSESSMENT_LIMIT = 5;

export const DEFAULT_ASSESSMENT_LIMIT_OFFSET = { limit: WOUND_ASSESSMENT_LIMIT, offset: 0 };

export const ADT_ACTION_MAP = {
    discharged: "Re-Admit",
    admitted: "Discharge",
    readmitted: "Discharge",
  };

export const UN_ASSESS_WOUND_TYPE = [
  {
    key: "patientrefusal",
    value: "Patient Refusal",
    desc: "Patient refused the wound evaluation for that week.",
    icon: <i className="fa fa-user" aria-hidden="true" />,
  },
  {
    key: "bedhold",
    value: "Bed Hold",
    desc: "Patient is on bed hold and unavailable for wound assessment.",
    icon: <i className="fa fa-bed" aria-hidden="true" />,
  },
  {
    key: "transfertohospital",
    value: "Transfer to hospital",
    desc: "Patient was transferred to a hospital and was unavailable for wound assessment.",
    icon: <Transfertohospital />,
  },
  {
    key: "outoffacility",
    value: "Out of facility",
    desc: "Patient was temporarily out of the facility and unavailable for wound assessment.",
    icon: <Outoffacility />,
  },
  {
    key: "other",
    value: "Other",
    desc: "Enter the reason why the wound could not be assessed.",
    icon: <Other />,
  },
];